import { Box, IconButton } from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";

const ActionsCellPlain = (props) => {
  const { table, row } = props;
  // table state
  const { editRowIndex, setEditRowIndex } = table.options.state;
  // rowState

  const currentIndex = row.id;

  // buttons
  return (
    <>
      <Box width={"100%"}>
        <Box display={"flex"} justifyContent={"center"}>
          <IconButton
            className="action-button"
            onClick={() => {
              setEditRowIndex(currentIndex);
            }}
          >
            <Edit />
          </IconButton>
        </Box>
      </Box>
    </>
  );
};

export default ActionsCellPlain;
